module.exports = __webpack_public_path__ + "img/profile-photo-upload.f88e32ee.svg";